import {  ITerceirizacaoRepository } from "../../repositories/terceirizacao_repository";
import { ICreateConfigPagamentoUseCase } from "../../../presentation/useCases/create/create_config_pagamento_use_case";

// CreateConfigPagamentoUseCase


export class CreateConfigPagamentoUseCase implements ICreateConfigPagamentoUseCase {
  constructor(private readonly repository: ITerceirizacaoRepository) {}

  async createConfigPagamento( IdMedicaoTerceirizacao: number | null, Nome: string | null, AVista: number | null, NrParcelas: number | null, TipoData: number | null, NroDias: number | null, ValorTotal: number | null, DataPgto: Date | null,  IdTipoConta: number | null, FormaPagamento: string | null, Observacao: string | null, InformacoesGerais: string | null, NrNotaFiscalEspecifica: string | null, ValorEntrada: number | null, DataEntrada: Date | null,  IdSubconta: number | null, DiasEntreParcelas: number | null): Promise<void> {
    
    await this.repository.createConfigPagamento(IdMedicaoTerceirizacao, Nome, AVista, NrParcelas, TipoData, NroDias, ValorTotal, DataPgto,  IdTipoConta, FormaPagamento, Observacao, InformacoesGerais, NrNotaFiscalEspecifica, ValorEntrada, DataEntrada, IdSubconta, DiasEntreParcelas
    );
  }
}
